<template>
  <div class="notecontainer_internal" :style="getPosition">
    <svg
      :id="this.config.id"
      class="jazzternote hidden-sm-and-down"
      :height="getWidthAndHeight"
      :width="getWidthAndHeight"
      viewBox="0 0 100 100"
      v-bind:style="config.style"
      v-prlx="{
        custom: true,
        limit: { min: getMinLimit, max: getMaxLimit },
      }"
    >
      <!-- <g
        fill="none"
        stroke="#E67C2D"
        :stroke-width="this.config.strokeWidth"
        opacity="0.696"
      >
        <circle cx="50" cy="50" r="30" fill="none" /> 
      </g> -->
      <g
        fill="none"
        stroke="#E67C2D"
        :stroke-width="this.config.strokeWidth"
        opacity="0.696"
      >
        <path
          d="M 50 50 m -30 0 
          a 30 30 0 1 0 60 0
          a 30 30 0 1 0 -60 0"
        />
        <!-- d="M20 5, 20 a1, 1 0 0, 0 35, 0" -->
        <!-- d="
          M cx cy
          m -r, 0
          a r,r 0 1,0 (r * 2),0
          a r,r 0 1,0 -(r * 2),0
          " -->
      </g>
    </svg>
  </div>
</template>


<script type="text/javascript" src="/node_modules/vue-prlx/dist/v-prlx.js"></script>
<script>
export default {
  name: "NoteCircle",
  components: {},
  props: ["config"],
  computed: {
    // getRotation() {
    //   var rotation = this.config.rotation ? this.config.rotation : "0";
    //   return "rotate(" + rotation + ", 50, 50)";
    // },
    getWidthAndHeight() {
      var widht = this.config.width ? this.config.width : "420";
      return widht;
    },
    getPosition() {
      var top = this.config.top ? this.config.top : "0";
      var left = this.config.left ? this.config.left : "0";

      var display_factor = 1;

      var factor = window.innerWidth / 3200;
      console.log("WS: " + factor);

      // console.log("top: " + top + "px;left: " + left + ";");
      return "top: " + top + "px;left: " + left * factor + "px;";
    },
    getMinLimit() {
      return this.config.minLimit;
    },
    getMaxLimit() {
      return this.config.maxLimit;
    },
  },
  mounted() {
    console.log(this.getMyValue);
    var note = document.getElementById(this.config.id);
    // note.style.border = "1px red solid";
    // note.style.transform = "rotateZ(calc(var(--parallax-value) * 1deg)) transformY(calc(calc(var(--parallax-value) * -1px)))";
    // note.style.transform = "translateY(calc(calc(var(--parallax-value) * -0.8px))) rotateZ(calc(var(--parallax-value) * 0.5deg))";
    note.style.transform = this.config.transform;
    // note.setAttribute("prlx", "{fromBottom: true}");
    // var note = document.getElementById("jazzternote");
  },
  methods: {
    test() {
      this.$forceUpdate(); // Notice we have to use a $ here
    },
  },
};
</script>

<style lang="scss" scoped>
.notecontainer_internal {
  position: absolute;
  z-index: 0;
  pointer-events:none;
}

.jazzternote {
  position: absolute;
  pointer-events:none;
  // stroke-dasharray: 1;
  // transform: rotateZ(calc(var(--parallax-value) * 1deg + 90)) translateY(calc(calc(var(--parallax-value) * -1px)));
  // transform: rotateZ(calc(var(--parallax-value) * 1deg))
}
</style>